import { Col, Menu, Row } from "antd";
import { GitBranch, Cloud, Container, MessageSquare } from "lucide-react";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import PageContentWrapper from "../../components/PageContentWrapper";
import { PageHeader } from "@ant-design/pro-layout";
import { useRecoilValue } from "recoil";
import { currentProjectState } from "../../recoil/project";

export default function ProjectIntegrationsRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const currentProject = useRecoilValue(currentProjectState);
    const [activeTab, setActiveTab] = useState("git");

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[4] || "git");
    }, [location.pathname]);

    return (
        <PageContentWrapper
            size="large"
            header={
                <PageHeader
                    title="Integrations"
                />
            }
        >
            <Row gutter={24}>
                <Col span={6}>
                    <Menu
                        mode="inline"
                        className="ant-card-bordered"
                        selectedKeys={[activeTab]}
                        onSelect={(item) => {
                            navigate(item.key);
                            setActiveTab(item.key);
                        }}
                        items={[
                            {
                                key: "git",
                                label: "Git",
                                icon: <GitBranch size={16} />
                            },
                            {
                                key: "cloud",
                                label: "Cloud Accounts",
                                icon: <Cloud size={16} />
                            },
                            {
                                key: "container",
                                label: "Container Registries",
                                icon: <Container size={16} />
                            },
                            {
                                key: "slack",
                                label: "Slack",
                                icon: <MessageSquare size={16} />
                            }
                        ]}
                    />
                </Col>
                <Col span={18}>
                    <Outlet context={{ projectDetails: currentProject }} />
                </Col>
            </Row >
        </PageContentWrapper>
    )
}